import { TextileHelper } from '../helpers/TextileHelper';
import { Module } from '../Module';

interface TextileScope extends ng.IScope {
  tbTextile: string;
  removeTrailingImage: boolean;
}

// A directive for formatting textile content.
Module.instance().directive('tbTextile', <any[]>[
  '$sanitize',
  ($sanitize: ng.sanitize.ISanitizeService) => {
    return {
      restrict: 'A',
      scope: {
        tbTextile: '<',
        removeTrailingImage: '<',
      },
      link: (scope: TextileScope, element: JQuery) => {
        element.addClass('tb-textile tb-enable-selection');
        scope.$watch('tbTextile', (newVal: string) => {
          const text = scope.removeTrailingImage ? newVal.replace(TextileHelper.TRAILING_IMAGE, '') : newVal;
          const html = TextileHelper.getSanitizedHtmlFromTextile(text, $sanitize);
          if (html !== null) {
            element.html(html);
            element.find('a').not('[target]').attr('target', '_blank');
          } else {
            element.text(newVal);
          }
        });
      }
    };
  }
]);

// This directive extracts plain text from textile formatted content.
Module.instance().directive('tbTextilePlaintext', <any[]>[
  '$sanitize',
  ($sanitize: ng.sanitize.ISanitizeService) => {
    return {
      restrict: 'A',
      link: (scope: ng.IScope, element: JQuery, attrs: ng.IAttributes) => {
        scope.$watch(attrs['tbTextilePlaintext'], (newVal: string) => {
          const text = TextileHelper.getPlainTextFromTextile(newVal, $sanitize);
          element.text(text);
        });
      }
    };
  }
]);
